import { Descriptions, Table } from 'antd';
import type { MultiPromptDto } from '../multi-prompt-model';
import { getDescription } from '../utils';

export const MultiPromptTable = (props: {
  segments?: MultiPromptDto[];
  extraPrompt?: string;
}) => {
  return (
    <Table
      size="small"
      tableLayout="fixed"
      scroll={{ x: 1000 }}
      dataSource={props.segments}
      rowKey={(row, index) => `${index}_${row.shot_id}`}
      showHeader={false}
      columns={[
        {
          title: '镜号',
          width: 100,
          render: (_, __, index) => (
            <>
              <span className="font-bold">镜号：</span>
              {index + 1}
            </>
          ),
        },
        {
          title: '时长',
          width: 120,
          render: (_, row) => (
            <>
              <span className="font-bold">时长：</span>
              {row.duration}秒
            </>
          ),
        },
        {
          title: '镜头目的',
          render: (_, row) => (
            <>
              <span className="font-bold">镜头目的：</span>
              {row.shot_purpose}
            </>
          ),
        },
        {
          title: '镜头',
          render: (_, row) => (
            <>
              <span className="font-bold">镜头：</span>
              {row.shot_type}
            </>
          ),
        },
        {
          title: '运镜',
          render: (_, row) => (
            <>
              <span className="font-bold">运镜：</span>
              {row.camera_movement}
            </>
          ),
        },
        {
          title: '画面关键词',
          render: (_, row) => (
            <>
              <span className="font-bold">画面关键词：</span>
              {row.visual_keywords?.join('，')}
            </>
          ),
        },
      ]}
      expandable={{
        defaultExpandAllRows: true,
        expandedRowRender: (item, _, indent) => {
          return (
            <Descriptions
              styles={{
                root: {
                  paddingLeft: indent * 48,
                },
              }}
              column={1}
              layout="vertical"
              items={[
                {
                  label: '画面描述',
                  children: getDescription(item),
                },
                {
                  label: '台词/字幕/情绪',
                  children: item.dialogue_subtitle_emotion,
                },
              ]}
            ></Descriptions>
          );
        },
      }}
      title={
        props.extraPrompt?.length
          ? () => (
              <>
                <span className="font-bold">重点：</span>
                {props.extraPrompt}
              </>
            )
          : void 0
      }
      pagination={false}
    ></Table>
  );
};
